import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import useYupValidationResolver from '../../../components/form/useYupValidationResolver';

export type TimeEntryNotesFormData = {
  notes: string;
};

type Props = {
  notes: string | null;
  required?: boolean;
};

const fieldName = 'notes';

export const useTimeEntryNotesForm = ({ notes, required = false }: Props) => {
  const { t } = useTranslation();
  const validationSchema = useMemo(() => {
    const base = yup.string().max(32768).ensure().trim();
    return yup.object().shape<TimeEntryNotesFormData>({
      notes: required
        ? base.required(
            t('timeTracking.current.stopTrackingModal.notesRequired'),
          )
        : base,
    });
  }, [required, t]);

  const defaultValues = {
    notes: notes ?? '',
  };
  const form = useForm<TimeEntryNotesFormData>({
    defaultValues,
    validationResolver: useYupValidationResolver(validationSchema),
  });

  return useMemo(
    () => ({
      fieldName,
      form,
    }),
    [form],
  );
};
